<template>
    <div class="copy_ynjc">Copyright &copy; 2012-{{ footerTime }} 北京亿和博嘉教育科技有限公司&nbsp;&nbsp;版权所有&nbsp;&nbsp;京ICP备12019974号</div>
</template>
<script>
    export default {
        components: {},
        data() {
            return {
                footerTime: new Date().getFullYear()
            }
        },
    }
</script>